import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configure } from "@yoskutik/react-vvm";
import { container } from "tsyringe";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

configure({
  vmFactory: (VM) => container.resolve(VM),
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
